import practiceApi from '../../api/rest/practiceApi';
import {setPractices} from '../actions/practiceAction';
import {EResponseCode} from '../../const/dataEnum';

export const fetchPracticesByDepartment = (deptId) => async (dispatch) => {
  try {
    const response = await practiceApi.getPracticeByDeptId(deptId);
    const {data, responseCode} = response;

    if (responseCode === EResponseCode.NO_ERROR) {
      const formatted = data.map((p) => ({
        id: p.id,
        text: p.practiceName,
        group: '',
        data: p,
      }));

      dispatch(setPractices(deptId, formatted));
    }
  } catch (error) {}
};

const getPracticeByDeptId = (deptId) => async (dispatch) => {
  const res = await practiceApi.getPracticeByDeptId(deptId);
  if (res.data) {
    return res.data;
  }
  return null;
};

const getPracticeById = (practices, practiceId) => {
  const practice = practices.find((item) => item.id === practiceId);
  return practice;
};

const practiceBusiness = {
  getPracticeByDeptId,
  getPracticeById,
  fetchPracticesByDepartment,
};

export default practiceBusiness;
